import auth from './auth'
import agreement from './agreement'
import contract from './contract'
import terms from './terms'
import credential from './credential'
import loan from './loan'
import kyc from './kyc'
import store from './store'
import document from './document'
import earlyPayment from './earlyPayment'
import evaluation from './evaluation'
import choice from './choice'
import fundaPaygate from './fundaPaygate'
import withdrawalAccount from './withdrawalAccount'
import collectionAccount from './collectionAccount'
import service from './service'
import user from './user'
import crowdFunding from './crowdFunding'
import wholesaler from './wholesaler'
import creditpay from './creditpay'
import code from './code'
import loansRequest from './loansRequest'
import loanMarketplace from './loanMarketplace'
import myfinbiz from './myfinbiz'

export default {
  ...agreement,
  ...auth,
  ...choice,
  ...collectionAccount,
  ...contract,
  ...credential,
  ...document,
  ...earlyPayment,
  ...evaluation,
  ...fundaPaygate,
  ...terms,
  ...kyc,
  ...loan,
  ...service,
  ...store,
  ...user,
  ...withdrawalAccount,
  ...crowdFunding,
  ...wholesaler,
  ...creditpay,
  ...code,
  ...loansRequest,
  ...loanMarketplace,
  ...myfinbiz,
}
